import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from '../../ApplicationRecord';
import type AuditsExport from '../AuditsExport';

@Model()
class AuditsExportsProvisionExport extends ApplicationRecord {
  static jsonapiType = 'audits-exports-provision_exports' as const;

  // Attributes
  @Attr() year!: number;

  // Extra-attributes

  // Relationships
  @HasOne('audits-exports') export!: AuditsExport;
}

export default AuditsExportsProvisionExport;
